// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1mxK6","active":"NavigationItem_active__LCKAL"};